import { Question } from './question.interface';
import { ContentLocalesI } from './session.types';
import {ListResponse} from "~src/services/api/pulseCheck";

export enum TopicComments {
  None = "disabled",
  Optional = "optional",
  Mandatory = "mandatory",
}

export enum TopicSubject {
  General = 'general',
  People = 'people',
  Groups = 'groups',
  All = '',
}

export type TopicRespI = ListResponse<Topic>

export interface Topic {
  archived: boolean;
  comments: TopicComments;
  createdAt: string;
  createdBy: string;
  description: ContentLocalesI;
  framework: boolean;
  id: string;
  name: ContentLocalesI;
  originalDescription: ContentLocalesI;
  originalName: ContentLocalesI;
  private: boolean;
  questionCount: number;
  questions?: Question[];
  scaleId: string;
  scaleVersionId: string;
  subject: TopicSubject;
  updatedAt: string;
  updatedBy: string;
}

export type TopicsDistribution = { [key in TopicSubject]: number };

export interface ESTopic {
  // the topic interface from reporting
  id: string;
  scale_id: string;
  scale_version_id: string;
  type: TopicSubject;
  name: ContentLocalesI;
  description: ContentLocalesI;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string;
  private: boolean;
}

export function topicToEsTopic(topic: Topic): ESTopic {
  return {
    id: topic.id,
    scale_id: topic.scaleId,
    scale_version_id: topic.scaleVersionId,
    type: topic.subject,
    name: topic.name,
    description: topic.description,
    created_at: topic.createdAt,
    updated_at: topic.updatedAt,
    created_by: topic.createdBy,
    updated_by: topic.updatedBy,
    private: topic.private,
  };
}
/*
export function ESTopicToTopic(topic: ESTopic): Topic {
  return {
    id: topic.id,
    scaleId: topic.scale_id,
    scaleVersionId: topic.scale_version_id,
    subject: topic.type,
    name: topic.name,
    description: topic.description,
    createdAt: topic.created_at,
    updatedAt: topic.updated_at,
    private: topic.private,
  };
}
*/
